import React from 'react'
import styled from '@emotion/styled'
import { stylesIf, themeColor } from 'utils/styles'
import { Paragraph, Header, Icon, Button, Tooltip } from 'components/patterns'
import { CollapsibleWidget } from 'components/chec'

export const StyledCollapsibleWidget = styled(CollapsibleWidget)`
  && {
    border: 0px;
    width: 100%;
    .collapsible-widget_title {
      cursor: pointer;
    }

    .collapsible-widget_header {
      background-color: transparent;
      background: transparent;
      border: 0px;
      height: 16px;
      margin-bottom: 4px;

      > div {
        flex-direction: row-reverse;
        width: 360px;
        justify-content: inherit;
      }
    }
  }
`

export const StyledParagraph = styled(Paragraph)`
  margin-top: 16px;
  margin-bottom: 5px;
`

export const DraggableUnassignedPartList = styled.div`
  border-bottom: 1px solid ${themeColor('grey')};
  padding: 32px 0;
`

export const ListHeaderAndIcon = styled.div((props) => {
  const { index, groupLength } = props

  return `
    ${stylesIf(
      index > 0,
      `border-top: 1px solid ${themeColor('grey', props)};`
    )}
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    ${stylesIf(groupLength !== 0, ``)}
  `
})

export const DragIcon = styled.div`
  margin-top: -8px;
  margin-left: 3px;
`

export const Group = styled.div`
  border-top: 1px solid ${themeColor('grey')};
  margin: 10px 0;
  padding: 10px 0;
`

export const ListHeader = (props) => <StyledListHeader {...props} type="h3" />

const StyledListHeader = styled(Header)`
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  margin-bottom: 10px;
  padding-top: 10px;
`

export const SectionHeader = styled.span((props) => {
  const { paragraphColor } = props.theme.color

  return `
  color: ${paragraphColor};
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  margin: 0;
  padding: 0;
  `
})

export const UnAssignedPartHeaderIcon = styled(Icon)`
  display: inline;
  margin-right: 8px;
`

export const UnAssignedPartHeader = styled.h3((props) => {
  const { disabled } = props

  return `
  font-weight: bold;
  padding-top: 10px;
  ${stylesIf(disabled, `color: ${themeColor('greyPrimary', props)};`)}
  display: inline;
`
})

export const ShowDetailsButton = styled(Button)`
  margin-left: 4px;
  font-size: 12px;
`

export const AddMSFButtons = styled(Button)`
  && {
    margin: 0;
    margin-left: auto;
    height: 24px;
    flex-shrink: 0;
    white-space: nowrap;
    ${({ compact }) => compact && 'padding: 4px 11px;'}
    color: var(--Blue-Primary-Blue, #0b2e6b);
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.1px;
    border-radius: 3px;
    border: 1px solid var(--Slate-Light-Slate, #8c96a2);
    background: var(--White-White-Primary, #fff);
    &[disabled],
    &[aria-disabled='true'] {
      color: #8c96a2 !important;
      background: #f5f5f5 !important;
      border-color: #d9d9d9 !important;
      cursor: not-allowed !important;
    }
  }
`

export const CancelMSFButton = styled(AddMSFButtons)`
  && {
    color: ${themeColor('errorPrimary')};
    background-color: ${themeColor('greySecondary')};
    border-color: ${themeColor('slateLight')};

    &:hover,
    &:focus {
      color: ${themeColor('whitePrimary')};
      background-color: ${themeColor('errorPrimary')};
      border-color: ${themeColor('errorPrimary')};
    }
  }
`

export const StyledTooltip = styled(Tooltip)`
  margin-left: auto;
`

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`
